import { useEffect, useMemo, useRef, useState } from "react";
import "../styles/App.css";
import "../styles/time-table.css";
import { SubStdSelContext } from "../../SubStdSelContext";
import Add_class_material from "./day-event/Add_class_material";
import {
  Day,
  Inject,
  ScheduleComponent,
  ViewDirective,
  ViewsDirective,
  Week,
  Resize,
  DragAndDrop,
} from "@syncfusion/ej2-react-schedule";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import CreateTimeTable from "./day-event/createTimeTable";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import { getTimeTable } from "../services/time-table-service";
import TimeTableWeekEvent from "./week-event/Time-table-week-event";
import TimeTableDayEvent from "./day-event/Time-table-day-event";
import SciencePopUp from "./PopUp/Science/SciencePopUp";
import { useNavigate } from "react-router-dom";
import { fetchAllTeacherList } from "../../redux/initialDataSlice";
import { useDispatch } from "react-redux";
import RotatingNotices from "./day-event/rotatingNotices";
import axios from "../../axios";
import moment from "moment";
import SummaryLectureUi from "../../ContentManagement/LiveSession/LiveSessionDetail.js/SubjectDatailsCM/summaryLectureUi";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"; // calendar icon
import { IP } from "../../internalServer";
import { toast } from "react-toastify";
import JoinNowInstructions from "./day-event/JoinNowInstructions";

const { startOfWeek, endOfWeek } = require("date-fns");

let firstdayDefault;
let lastdayDefault;
let firstday;
let lastday;
let startday1;
let endday1;
let start_time1;
let end_time1;
let date;
const TimeTable = ({ leftSidebarSize }) => {
  let response6 = [];
  let response1 = [];
  var response2 = [];
  const helper4 = (item) => {
    return Object.entries(item).map(([name, value]) => ({ name, value }));
  };
  const navigate = useNavigate();
  const [createClick, setCreateClick] = useState(false);
  const [editClick, setEditClick] = useState(false);
  const [sucessNotice, setSucessNotice] = useState(false);
  const [viewAs, setViewAs] = useState(localStorage.getItem("viewAs") || "");
  const [stdArr, setStdArr] = useState([]);
  const [secArr, setSecArr] = useState([]);
  const [events, setEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [noticeData, setNoticeData] = useState([]);
  const [greeting, setGreeting] = useState("Good Day");
  const [teacherListPopup, setTeacherListPopup] = useState(false);
  const [todayClassData, setTodayClassData] = useState(null);
  const [lectureSelectedDate, setLectureSelectedDate] = useState(new Date());
  const [adjustedTime, setAdjustedTime] = useState("06:00");
  const [timeTableSessionStartDate, setTimeTableSessionStartDate] =
    useState(null);
  const [isCreateLinkClicked, setIsCreateLinkClicked] = useState(false);
  const [isJoining, setIsJoining] = useState(false);

  const teacherName = JSON.parse(localStorage.getItem("UserName"));
  const gender = JSON.parse(localStorage.getItem("gender"));
  const academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  const timetableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const [monthName, setMonthName] = useState([]);

  const [stdSelection, setStdSelection] = useState(
    localStorage.getItem("stdSelection") || "",
  );
  const [secSelection, setSecSelection] = useState(
    localStorage.getItem("secSelection") || "",
  );
  const [youtubeEvent, setYoutubeEvent] = useState(null);
  const schoolId = JSON.parse(localStorage.getItem("schoolId"));
  const teacherId = JSON.parse(localStorage.getItem("Teacher_id"));
  const [openInstruction, setOpenInstruction] = useState(false);
  const [meetingUrl, setMeetingUrl] = useState("");
  const scheduleRef = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    const school_id = localStorage.getItem("schoolId");
    if (school_id) {
      dispatch(fetchAllTeacherList(school_id));
    }
  }, [dispatch]);

  const jsonRole_CTinformation = useMemo(() => {
    const CTRole_Information = localStorage.getItem("role_as_class_teacher");
    return CTRole_Information ? JSON.parse(CTRole_Information) : [];
  }, []);

  const jsonRole_Coinformation = useMemo(() => {
    const CoRole_Information = localStorage.getItem("role_as_co_ordinator");
    return CoRole_Information ? JSON.parse(CoRole_Information) : [];
  }, []);

  const jsonRole_Geinformation = useMemo(() => {
    const general_role = localStorage.getItem("general_role");
    return general_role ? JSON.parse(general_role) : [];
  }, []);

  const today = new Date();
  const TodayDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1,
  ).padStart(2, "0")}-${today.getFullYear()}`;

  const dateFormatToGetdate = (date) => {
    const startdate = new Date(date);
    const outputDate = startdate.toUTCString().replace(",", "");
    let outputDate1 = outputDate.concat("+0530");
    return outputDate1;
  };

  const handleDataPopulate = async (
    standardId,
    sectionId,
    startDate,
    endDate,
  ) => {
    try {
      setEvents([]);

      if (!startDate || !endDate) return;

      let res = [];

      // ✅ MY LECTURE FLOW
      if (viewAs === "option4") {
        const teacherId = JSON.parse(localStorage.getItem("Teacher_id"));
        const schoolId = JSON.parse(localStorage.getItem("schoolId"));

        startday1 = dateFormatToGetdate(startDate);
        endday1 = dateFormatToGetdate(endDate);
        let finalStartDay = new Date(startday1);
        let finalendDay = new Date(endday1);

        const formatDate = (date) => {
          const d = new Date(date);
          return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
            2,
            "0",
          )}-${String(d.getDate()).padStart(2, "0")}`;
        };

        const start = formatDate(startDate);
        const end = formatDate(endDate);

        const response = await axios.get(
          `/api/v1/timetableforTeacher/get/schoolId/${schoolId}/teacherId/${teacherId}/startDate/${start}/endDate/${end}?academic_year_id=${academicYearId}&timetable_session_id=${timetableSessionId}`,
        );

        const data = response.data.data || [];

        for (let i = 0; i < data.length; i++) {
          const schedules = data[i].schedules || [];

          for (let j = 0; j < schedules.length; j++) {
            const schedule = schedules[j];

            for (let k = 0; k < schedule.special_lectures.length; k++) {
              schedule.special_lectures[k].lactureType = "special_lacture";
              response6.push(schedule.special_lectures[k]);
            }

            for (let k = 0; k < schedule.lectures.length; k++) {
              schedule.lectures[k].lactureType = "lacture";
              response6.push(schedule.lectures[k]);
            }

            for (let k = 0; k < schedule.general_categories.length; k++) {
              schedule.general_categories[k].lactureType = "general_lacture";
              response6.push(schedule.general_categories[k]);
            }
          }
        }
        response6.forEach((i) => {
          res.push(helper2(i, startDate, finalStartDay, finalendDay));
        });
      }

      // ✅ NORMAL FLOW
      else {
        if (!standardId || !sectionId) return;

        res = await getTimeTable(standardId, sectionId, startDate, endDate);
      }

      setEvents(Array.isArray(res) ? res : []);

      // month label logic (same as yours)
      const formatDateRange = (startDate, endDate) => {
        if (!startDate || !endDate) return "";
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

        const start = new Date(startDate);
        const end = new Date(endDate);

        if (
          start.getMonth() === end.getMonth() &&
          start.getFullYear() === end.getFullYear()
        ) {
          return `${monthNames[start.getMonth()]} ${start.getDate()} - ${end.getDate()}, ${start.getFullYear()}`;
        }

        return `${monthNames[start.getMonth()]} ${start.getDate()} - ${monthNames[end.getMonth()]} ${end.getDate()}, ${end.getFullYear()}`;
      };

      setMonthName(formatDateRange(startDate, endDate));
    } catch (error) {
      console.error("Error fetching timetable:", error);
      setEvents([]);
      setMonthName("");
    }
  };

  setTimeout(() => {
    setIsCreateLinkClicked(false);
  }, 5000);

  const closePopup = () => {
    if (scheduleRef && scheduleRef.current) {
      scheduleRef.current.closeQuickInfoPopup();
    }
  };
  const closeTimeTablePopup = async () => {
    closePopup();
  };

  const handleSucessNotice = () => {
    setSucessNotice(true);
    setTimeout(() => {
      setSucessNotice(false);
    }, 10000); // 10 seconds in milliseconds
  };

  const redirectToLiveStudio = () => {
    const a = document.createElement("a");
    a.href = meetingUrl;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  useEffect(() => {
    let arr = [];
    if (viewAs !== "option1") {
      setStdArr([]);
      setSecArr([]);
    }

    // Check if 'viewAs' is selected
    if (viewAs === "option1") {
      // setStdSelection("");
      setEvents([]);
      jsonRole_CTinformation.forEach((item) => {
        if (item.is_class_teacher === true) {
          const idExists = arr.some((obj) => obj["id"] === item.standard_id.id);
          if (!idExists) {
            arr.push({
              id: item.standard_id.id,
              name: item.standard_id.name,
            });
          }
        }
      });
      setStdArr(arr);
    } else if (viewAs === "option2") {
      // setStdSelection("");
      setEvents([]);
      jsonRole_Coinformation.forEach((item) => {
        if (item.is_class_co_ordinator === true) {
          const idExists = arr.some((obj) => obj["id"] === item.standard_id.id);
          if (!idExists) {
            arr.push({
              id: item.standard_id.id,
              name: item.standard_id.name,
            });
          }
        }
      });
      setStdArr(arr);
    } else if (viewAs === "option3") {
      // setStdSelection("");

      setEvents([]);
      jsonRole_Geinformation.forEach((item) => {
        if (
          (item.is_class_co_ordinator === false &&
            item.is_class_teacher === false) ||
          !item.is_class_co_ordinator ||
          !item.is_class_co_ordinator
        ) {
          const idExists = arr.some((obj) => obj["id"] === item.standard_id.id);
          if (!idExists) {
            arr.push({
              id: item.standard_id.id,
              name: item.standard_id.name,
            });
          }
        }
      });
      setStdArr(arr);
    } else if (viewAs === "option4") {
      setStdArr([]);
      setSecArr([]);
      setStdSelection("");
      setSecSelection("");
      setEvents([]);
    } else {
      setStdSelection("");
      setSecSelection("");
      setEvents([]);
      localStorage.removeItem("stdSelection");
      localStorage.removeItem("secSelection");
    }
  }, [
    viewAs,
    jsonRole_CTinformation,
    jsonRole_Coinformation,
    jsonRole_Geinformation,
  ]);
  useEffect(() => {
    let arr1 = [];
    setSecArr([]);
    if (viewAs === "option1") {
      // setSecSelection("");
      jsonRole_CTinformation.forEach((item) => {
        if (item.standard_id.id === stdSelection) {
          arr1.push({
            id: item.section_id.id,
            name: item.section_id.name,
          });
        }
      });
      setSecArr(arr1);
    } else if (viewAs === "option2") {
      // setSecSelection("");
      jsonRole_Coinformation.forEach((item) => {
        if (item.standard_id.id === stdSelection) {
          arr1.push({
            id: item.section_id.id,
            name: item.section_id.name,
          });
        }
      });
      setSecArr(arr1);
    } else if (viewAs === "option3") {
      // setSecSelection("");
      jsonRole_Geinformation.forEach((item) => {
        if (item.standard_id.id === stdSelection) {
          arr1.push({
            id: item.section_id.id,
            name: item.section_id.name,
          });
        }
      });
      setSecArr(arr1);
    } else {
      setSecSelection("");
      localStorage.removeItem("secSelection");
    }
    // setSecArr([]);
  }, [stdSelection]);
  const handelDateChangeDefault = () => {
    let today = new Date();
    let dayOfWeek = today.getDay();
    let firstDay = new Date(today);
    firstDay.setDate(today.getDate() - dayOfWeek);
    let lastDay = new Date(today);
    lastDay.setDate(today.getDate() + (6 - dayOfWeek));
    firstdayDefault = firstDay.toUTCString();
    lastdayDefault = lastDay.toUTCString();
  };
  useEffect(() => {
    handelDateChangeDefault();
  }, []);
  useEffect(() => {
    localStorage.setItem("viewAs", viewAs);
    localStorage.setItem("stdSelection", stdSelection);
    localStorage.setItem("secSelection", secSelection);
    if (
      firstdayDefault &&
      lastdayDefault &&
      (viewAs === "option4" || (stdSelection && secSelection))
    ) {
      handleDataPopulate(
        stdSelection,
        secSelection,
        firstdayDefault,
        lastdayDefault,
      );
    }
  }, [viewAs, stdSelection, secSelection]);
  const onEventRendered = (args) => {
    const currentTime = new Date();
    const isHappened = currentTime.getTime() > args.data?.EndTime?.getTime();

    // Base color coming from data
    let displayColor = args.data.DisplayColor || "#3B82F6";

    // ✅ Replace too-light default color with dark blue
    if (displayColor.toUpperCase() === "#DFF7F9") {
      displayColor = "#0D47A1";
    }

    if (isHappened && args.data.LactureType !== "general_lacture") {
      args.element.style.backgroundColor = displayColor;
      args.element.style.opacity = 0.5;
    } else if (
      args.data.LactureType === "general_lacture" ||
      args.data.LectureName === "Assembly"
    ) {
      args.element.style.backgroundColor = "#E5E7EB";
    } else {
      args.element.style.backgroundColor = displayColor;
    }
  };

  const onActionBegin = (args) => {
    if (args.requestType === "toolbarItemRendering") {
      args.items = args.items.slice(3);
    }
    if (args?.event?.target?.innerText === "TODAY") {
      setSelectedDate(new Date());
    }
  };

  const onCellDoubleClick = (args) => {
    // Implementation for onCellDoubleClick
    // return <CreateClassLink />;
    return <></>;
  };

  const headerTemplate = (props) => {
    // Implementation for headerTemplate
    const currentTime = new Date();
    const isHappened = currentTime.getTime() > props?.EndTime?.getTime();
    return props.LactureType !== "general_lacture" ? (
      <div className="quick-info-header">
        <div className="quick-info-header-content">
          <div
            className="heder_template"
            style={{ background: isHappened ? "#808080" : props?.DisplayColor }}
          ></div>
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const helper2 = (item, startday, finalStartDay, finalendDay) => {
    start_time1 = formatTime(item.start_time);
    end_time1 = formatTime(item.end_time);
    function formatTime(time) {
      var timeString = time.toString();
      while (timeString.length < 4) {
        timeString = "0" + timeString;
      }
      return timeString.slice(0, 2) + ":" + timeString.slice(2, 4) + ":00";
    }
    const resTimeManageStart = () => {
      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
        All: 8,
      };
      let dayNo = dayMap[item.day];
      // Convert the start and end dates to UTC timestamps
      const startTimestamp = finalStartDay.getTime();
      const endTimestamp = finalendDay.getTime();
      // Loop through all dates between the start and end dates
      for (
        let timestamp = startTimestamp;
        timestamp <= endTimestamp;
        timestamp += 24 * 60 * 60 * 1000
      ) {
        date = new Date(timestamp);
        // Check if the date matches the desired day of the week
        if (date.getDay() === dayNo) {
          const dateString = date;
          const date1 = new Date(dateString);
          let formattedDate = date1.toDateString();
          formattedDate = formattedDate.concat(
            ` ${start_time1} GMT+0530 (India Standard Time)`,
          );
          return formattedDate;
        }
      }
      // If no matching date was found, return null
      return null;
    };
    const resTimeManageEnd = () => {
      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
        All: 8,
      };
      let dayNo = dayMap[item.day];
      // Convert the start and end dates to UTC timestamps
      const startTimestamp = finalStartDay.getTime();
      const endTimestamp = finalendDay.getTime();
      // Loop through all dates between the start and end dates
      for (
        let timestamp = startTimestamp;
        timestamp <= endTimestamp;
        timestamp += 24 * 60 * 60 * 1000
      ) {
        date = new Date(timestamp);
        // Check if the date matches the desired day of the week
        if (date.getDay() === dayNo) {
          const dateString = date;
          const date1 = new Date(dateString);
          let formattedDate = date1.toDateString();
          formattedDate = formattedDate.concat(
            ` ${end_time1} GMT+0530 (India Standard Time)`,
          );
          return formattedDate;
        }
      }
      // If no matching date was found, return null
      return null;
    };
    //resTimeManage();
    const timeForAll = () => {
      let inputDate = startday;
      let date = new Date(inputDate);
      let year = date.getUTCFullYear();
      let month = String(date.getUTCMonth() + 1).padStart(2, "0");
      let day = String(date.getUTCDate()).padStart(2, "0");
      let formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    };
    const helper3 = (supplements) => {
      if (item.name === "general_lacture") {
      }
      response2 = [];
      response1 = [];
      const filtered = Object.entries(supplements || {})
        .filter(([key, value]) => value !== null)
        .reduce((obj, [key, value]) => {
          if (obj === undefined) {
            return undefined;
          }
          if (obj === null) {
            return null;
          }
          obj[key] = value;
          delete obj.id;
          return obj;
        }, {});

      response1.push(filtered);
      response1.forEach((i) => {
        response2 = helper4(i);
      });
      return response2;
    };
    let res1 = {
      Id: item.id,
      LectureName: item?.name,
      Subject: item?.subject?.name ? item?.subject?.name : item?.name,
      Subject_id: item?.subject?.id,
      StartTime: new Date(
        `${
          item.day === "All"
            ? `${timeForAll()}T${start_time1}`
            : resTimeManageStart()
        }`,
      ),
      EndTime: new Date(
        `${
          item.day === "All"
            ? `${timeForAll()}T${end_time1}`
            : resTimeManageEnd()
        }`,
      ),
      IsAllDay: false,
      Events: helper3(item.supplements),
      Supplement_id: item?.supplements?.id,
      Teacher: item?.teacher?.id,
      TeacherName: item?.teacher?.name,
      LactureType: item?.lactureType,
      DisplayColor: `#${item?.subject?.color}`,
      // lectureCategory: ,
      RecurrenceRule: `FREQ=${
        item.day === "All" ? "DAILY" : "WEEKLY"
      };INTERVAL=1;`,
    };
    return res1;
  };

  const contentTemplate = (props) => {
    return props.LactureType !== "general_lacture" ? (
      <>
        <div className="quick-info-content">
          {props?.elementType !== "cell" && (
            // <SciencePopUp event={props} refresh={closeTimeTablePopup} />
            <SummaryLectureUi
              event={props}
              scheduleRef={scheduleRef}
              readOnly
            />
          )}
        </div>
      </>
    ) : (
      <></>
    );
  };

  const dayEventTemplate = (props) => {
    return (
      <TimeTableDayEvent
        event={props}
        refetch={handleDataPopulate}
        SDate={firstday || firstdayDefault}
        EDate={lastday || lastdayDefault}
        refresh={closeTimeTablePopup}
        setIsCreateLinkClicked={setIsCreateLinkClicked}
      />
    );
  };

  const weekEventTemplate = (props) => {
    return (
      <TimeTableWeekEvent
        event={props}
        setIsCreateLinkClicked={setIsCreateLinkClicked}
      />
    );
  };

  const onCreated = (args) => {
    // Implementation for onCreated
  };

  const editorTemplate = (props) => {
    // Implementation for editorTemplate
  };
  const onPopupClose = (args) => {};
  const onPopupOpen = (args) => {
    try {
      if (isCreateLinkClicked) {
        args.cancel = true; // popup ko open hone se rok deta hai
        return;
      }

      if (args === "close") {
        onPopupClose(args);
      }
      if (args.type === "Editor") {
        args.cancel = true;
      }
      if (args.type === "RecurrenceAlert") {
        args.cancel = true;
      }
      if (args.type === "QuickInfo" && !args.data.Id) {
        args.cancel = true;
      }
      if (
        args.type === "QuickInfo" &&
        args.data.LactureType === "general_lacture"
      ) {
        args.cancel = true;
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleDateChange = (newDate) => {
    setSelectedDate(newDate?.value);
    var curr = newDate?.value;
    firstday = startOfWeek(curr);
    lastday = endOfWeek(curr);
    // scheduleRef.refresh();
    handleDataPopulate(stdSelection, secSelection, firstday, lastday);
  };

  const onDragStart = (args) => {
    args.cancel = true;
  };

  const onResizeStart = (args) => {
    args.cancel = true;
  };

  useEffect(() => {
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) {
      setGreeting("Good Morning");
    } else if (hour >= 12 && hour < 17) {
      setGreeting("Good Afternoon");
    } else if (hour >= 17 && hour < 21) {
      setGreeting("Good Evening");
    } else {
      setGreeting("Good Night");
    }
  }, []);

  const prefixTeacherName =
    gender === "M" ? `Mr. ${teacherName}` : `Ms. ${teacherName}`;

  useEffect(() => {
    if (!lectureSelectedDate) return;

    const formattedDate = moment(lectureSelectedDate).format("YYYY-MM-DD");

    const fetchData = async () => {
      try {
        const res = await axios.get(
          `/api/v1/timetableforTeacher/get/schoolId/${schoolId}/teacherId/${teacherId}/startDate/${formattedDate}/endDate/${formattedDate}?academic_year_id=${academicYearId}&timetable_session_id=${timetableSessionId}`,
        );
        setTodayClassData(res.data.data);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, [lectureSelectedDate, teacherId, schoolId]);

  const formattedEvents =
    todayClassData &&
    todayClassData.flatMap((timetable) =>
      timetable.schedules.flatMap((schedule) => {
        const standardName = timetable.standard?.name || "";
        const sectionName = timetable.section?.name || "";

        const standardId = timetable.standard?.id || "";
        const sectionId = timetable.section?.id || "";

        const lectureEvents = schedule.lectures.map((event) => {
          const start = moment(
            `${event.date} ${event.start_time}`,
            "YYYY-MM-DD HHmm",
          ).toDate();
          const end = moment(
            `${event.date} ${event.end_time}`,
            "YYYY-MM-DD HHmm",
          ).toDate();
          const now = new Date();

          let liveStatus = null;

          if (event?.supplements?.bbb_lecture) {
            if (now < start) liveStatus = "soon";
            else if (now >= start && now <= end) liveStatus = "live";
            else if (now > end) liveStatus = "ended";
          }

          return {
            id: event.id,
            title: `${standardName} ${sectionName}`,
            lectureName: `${event.subject.name} : ${event.name}`,
            start,
            end,
            type: "Lecture",
            color: event.subject.color,
            hasLive: event?.supplements?.bbb_lecture ? true : false,
            liveStatus,
            event: event,
            standardId: standardId,
            sectionId: sectionId,
            liveId: event?.supplements?.bbb_lecture,
          };
        });

        return [...lectureEvents];
      }),
    );

  useEffect(() => {
    const fetchTimeTableSessionData = async () => {
      if (!academicYearId) return;
      try {
        const res = await axios.get(
          `/api/v1/school/schoolSession/get/academicYear/${academicYearId}`,
        );
        const filteredData = res?.data?.data?.filter(
          (item) => item.timeTableSession._id === timetableSessionId,
        );
        setTimeTableSessionStartDate(filteredData[0]?.start_time);
      } catch (err) {
        console.log(err);
      }
    };

    fetchTimeTableSessionData();
  }, [academicYearId, timetableSessionId]);

  const smoothScrollTo = (element, to, duration = 500) => {
    const start = element.scrollTop;
    const change = to - start;
    const startTime = performance.now();

    const animateScroll = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // easeInOut
      const ease =
        progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;

      element.scrollTop = start + change * ease;

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  };

  useEffect(() => {
    if (!scheduleRef.current || events.length === 0) return;

    // 🔒 Get selected date from schedule
    const selectedDate = scheduleRef.current.selectedDate;
    if (!selectedDate) return;

    const today = new Date();

    // 🔥 DATE MATCH CHECK (ONLY TODAY)
    const isToday =
      selectedDate.getDate() === today.getDate() &&
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getFullYear() === today.getFullYear();

    if (!isToday) return; // ❌ NOT TODAY → DO NOTHING

    // ✅ TODAY ONLY LOGIC
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    setTimeout(() => {
      // 1️⃣ Hidden jump
      scheduleRef.current.scrollTo(`${hours}:${minutes}`);

      // 2️⃣ Scroll container
      const content = document.querySelector(".e-content-wrap");
      if (!content) return;

      // 3️⃣ Center scroll
      const targetScroll = content.scrollTop - content.clientHeight / 2;

      // 4️⃣ Smooth animation
      smoothScrollTo(content, targetScroll, 600);
    }, 300);
  }, [events]);

  useEffect(() => {
    if (
      !timeTableSessionStartDate ||
      typeof timeTableSessionStartDate !== "string"
    )
      return;

    // Optional: Make sure the format is HH:mm
    const timeParts = timeTableSessionStartDate.split(":");
    if (timeParts.length !== 2) return;

    const [hours, minutes] = timeParts.map(Number);

    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes - 30); // Subtract 30 minutes

    const newHours = String(date.getHours()).padStart(2, "0");
    const newMinutes = String(date.getMinutes()).padStart(2, "0");

    setAdjustedTime(`${newHours}:${newMinutes}`);
  }, [timeTableSessionStartDate]);

  useEffect(() => {
    if (!selectedDate) {
      const todayDate = moment().format("YYYY-MM-DD");
      setSelectedDate(todayDate);
    }
  }, [selectedDate]);

  const schoolInfo = JSON.parse(localStorage.getItem("UserInformation"));

  const IsYoutubeliveLectureEnabled =
    schoolInfo.school.liveClassType === "broadcast" ? true : false;

  const onJoinClick = async (event) => {
    if (isJoining) return;

    if (IsYoutubeliveLectureEnabled) {
      setYoutubeEvent(event);
      // 👉 ONLY open instructions
      setOpenInstruction(true);
      return;
    }

    // BBB normal flow
    await joinnow_helper(event);
  };

  const joinnow_helper = async (event) => {
    console.log("joinnow_helper clicked");
    try {
      setIsJoining(true);
      setIsCreateLinkClicked(true);

      const teacherJoinLink = await onJoinNowClick(event);

      if (!teacherJoinLink) {
        setIsJoining(false);
        return;
      }

      window.open(teacherJoinLink, "_blank", "noopener,noreferrer");
    } catch (err) {
      console.error(err);
    } finally {
      setIsJoining(false);
    }
  };

  const timeDiffWithCurrentTime = (endTimeString) => {
    var currentTime = new Date();
    var endTime = new Date(endTimeString);
    var diffInMs = endTime.getTime() - currentTime.getTime();
    var diffInMins = diffInMs / 60000;
    var finalResult = Math.round(diffInMins + 5);
    return finalResult;
  };

  const onJoinNowClick = async (event) => {
    let res = await axios.get(
      `/api/v1/videoConference/classes/getInfo?class_id=${event.liveId}`,
    );
    res = res.data.data;
    let newRes = {
      standard_id: event.standardId,
      teacher_id: res.teacher,
      subject_id: res.subject,
      section_id: event.sectionId,
      chapter_id: res.chapter,
      book_id: res.book,
      name: res.name,
      description: res.description,
      any_to_start_session: res.any_to_start_session,
      logo: `${IP}public/upload/logo/Logo.png`,
      record: true,
      mute_on_start: res.mute_on_start,
      welcome_message: res?.welcome_message,
      allow_mods_to_unmute_users: res.allow_mods_to_unmute_users,
      wallpaper:
        "https://cdn.pixabay.com/photo/2016/02/06/09/56/science-1182713_1280.jpg",
      dark_color: "##ffff",
      logout_url:
        "https://cdn.pixabay.com/photo/2016/02/06/09/56/science-1182713_1280.jpg",
      light_color: "#7BDEFF",
      primary_color: "blue",
      meeting_layout: "SMART_LAYOUT", //"VIDEO_FOCUS",
      lock_settings_disable_private_chat:
        res.lock_settings_disable_private_chat,
      require_moderator_approval: res.require_moderator_approval,
      auto_join: res.auto_join,
      allowedStudentsMode: res.allowedStudentsMode,
      allowedStudents: res.allowedStudents,
      webcams_only_for_moderator: true,
      lockSettingsHideUserList: true,
      banner_color: "#00000",
      banner_text: "Breathe4School",
      duration: timeDiffWithCurrentTime(event.end),
      add_to_live_session: res.addToLiveSession,
    };
    try {
      const res = await axios.post(
        `/api/v1/videoConference/classes/create?school_id=${schoolId}`,
        newRes,
      );

      if (res.data.status !== true) {
        toast.error("Failed to create video class.");
        return; // Don't proceed to second API
      }
      const _id = res.data.data.id;
      const viewer_name = JSON.parse(localStorage.getItem("UserName"));
      try {
        const startRes = await axios.get(
          `/api/v1/videoConference/classes/start/${_id}?moderator_name=${viewer_name}&school_id=${schoolId}`,
        );

        if (startRes.data.status === true) {
          return startRes.data.data;
        } else {
          toast.error("Failed to start video class.");
        }
      } catch (error) {
        console.error(error);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onInstructionContinue = async () => {
    console.log("onInstructionContinue clicked");
    setOpenInstruction(false);
    setIsJoining(true);

    try {
      const teacherJoinLink = await onJoinYtbNowClick(youtubeEvent);

      if (teacherJoinLink) {
        window.open(teacherJoinLink, "_blank", "noopener,noreferrer");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsJoining(false);
    }
  };
  const onJoinYtbNowClick = async (event) => {
    console.log("onJoinYtbNowClick", event);

    let res = await axios.get(
      `/api/v1/videoConference/classes/getInfo?class_id=${event.liveId}`,
    );
    res = res.data.data;
    console.log(res, "res for joon now click");
    let newRes = {
      standard_id: event.standardId,
      teacher_id: res.teacher,
      subject_id: res.subject,
      section_id: event.sectionId,
      chapter_id: res.chapter,
      book_id: res.book,
      name: res.name,
      description: res.description,
      any_to_start_session: res.any_to_start_session,
      logo: `${IP}public/upload/logo/Logo.png`,
      record: true,
      mute_on_start: res.mute_on_start,
      welcome_message: res?.welcome_message,
      allow_mods_to_unmute_users: res.allow_mods_to_unmute_users,
      wallpaper:
        "https://cdn.pixabay.com/photo/2016/02/06/09/56/science-1182713_1280.jpg",
      dark_color: "##ffff",
      logout_url:
        "https://cdn.pixabay.com/photo/2016/02/06/09/56/science-1182713_1280.jpg",
      light_color: "#7BDEFF",
      primary_color: "blue",
      meeting_layout: "SMART_LAYOUT", //"VIDEO_FOCUS",
      lock_settings_disable_private_chat:
        res.lock_settings_disable_private_chat,
      require_moderator_approval: res.require_moderator_approval,
      auto_join: res.auto_join,
      webcams_only_for_moderator: true,
      lockSettingsHideUserList: true,
      banner_color: "#00000",
      banner_text: "Breathe4School",
      duration: timeDiffWithCurrentTime(event.end),
      add_to_live_session: res.addToLiveSession,
      lecture_date: new Date(event.start).toISOString().split("T")[0],
      lecture_time: new Date(event.start).toTimeString().slice(0, 5),
      channelId: res.channelId,
    };
    try {
      const res = await axios.post(
        `/api/v1/videoConference/classes/create?school_id=${schoolId}`,
        newRes,
      );

      if (res.data.status !== true) {
        toast.error("Failed to create video class.");
        return; // Don't proceed to second API
      }
      const _id = res.data.data.id;
      const viewer_name = JSON.parse(localStorage.getItem("UserName"));
      try {
        const startRes = await axios.get(
          `/api/v1/videoConference/classes/start/${_id}?moderator_name=${viewer_name}&school_id=${schoolId}`,
        );

        if (startRes.data.status === true) {
          return startRes.data.data;
        } else {
          toast.error("Failed to start video class.");
        }
      } catch (error) {
        console.error(error);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getScheduleTitle = (selectedDate) => {
    if (!selectedDate) return "Your’s Classes";

    const today = new Date();
    const normalize = (d) =>
      new Date(d.getFullYear(), d.getMonth(), d.getDate());

    const selected = normalize(new Date(selectedDate));
    const todayDate = normalize(today);

    const diffDays = (selected - todayDate) / (1000 * 60 * 60 * 24);

    if (diffDays === 0) return "Today’s Schedule";
    if (diffDays === 1) return "Tomorrow’s Plan";

    return `Schedule · ${selected.toLocaleDateString("en-IN", {
      month: "short",
      day: "numeric",
    })}`;
  };

  return (
    <>
      {/* 
        <div className="righ_side_box">        
          {(createClick || fromFeedManual === "true") && (
            <CreateTimeTable helper1={handleClick} editClick={editClick} />
          )}
        </div>
       */}

      <div
        className={`orange-scrollBar`}
        style={{
          width: "100%",
          height: "100%",
          maxHeight: "600px",
          overflowY: "auto",
          boxSizing: "border-box",
        }}
      >
        <div class="container-fluid my-4 ">
          <div
            class="mx-auto px-4 py-3 text-white rounded position-relative overflow-hidden w-100 d-flex flex-column justify-content-start"
            style={{
              backgroundColor: "#0d47a1",
              backgroundImage: "url('images/shape.png')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <h4 class="fw-bold ms-2">
              {greeting} {prefixTeacherName}
            </h4>
            <p class="mb-1 ms-2">Have a Good day at work</p>

            <RotatingNotices noticeData={noticeData} />
          </div>
        </div>

        {/* today class container */}

        <div class="container-fluid my-2">
          <div class="card shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                <Box
                  sx={{
                    display: "inline-block",
                    px: 2,
                    py: 0.5,
                    borderRadius: "8px",
                    backgroundColor: "#f1f5f9",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "15px",
                      letterSpacing: "0.3px",
                      color: "#0f172a",
                    }}
                  >
                    {getScheduleTitle(lectureSelectedDate)}
                  </Typography>
                </Box>

                <div class="d-flex align-items-center gap-2">
                  {/* <button class="btn btn-sm btn-light">&lt;</button> */}
                  <DatePickerComponent
                    value={lectureSelectedDate}
                    placeholder="Choose a date"
                    format="dd MMMM yyyy"
                    floatLabelType="Auto"
                    change={(e) => setLectureSelectedDate(e.value)}
                    cssClass="e-outline" // Optional for material-style outline
                  />
                  {/* <button class="btn btn-sm btn-light">&gt;</button> */}
                </div>
              </div>

              {formattedEvents && formattedEvents?.length > 0 ? (
                <div
                  style={{ overflowX: "auto", width: "100%" }}
                  className=" orange-scrollBar"
                >
                  <div
                    className="d-flex gap-3 pb-2"
                    style={{ maxWidth: "1100px" }}
                  >
                    {formattedEvents
                      .slice()
                      .sort(
                        (a, b) =>
                          new Date(a.start).getTime() -
                          new Date(b.start).getTime(),
                      )
                      .map((event, idx) => {
                        const startTime = new Date(event.start);
                        const endTime = new Date(event.end);
                        const now = new Date();

                        const formattedTime = `${startTime.toLocaleTimeString(
                          "en-IN",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                          },
                        )} – ${endTime.toLocaleTimeString("en-IN", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        })}`;

                        const isPast = now > endTime;

                        return (
                          <>
                            {/* <div
                              className="border rounded p-3"
                              key={event.id || idx}
                              style={{
                                minWidth: "250px",
                                flex: "0 0 auto",
                                opacity: isPast ? 0.5 : 1,
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <div
                                  className={`text-white rounded px-2 py-1  d-inline-flex align-items-center gap-2`}
                                  style={{
                                    backgroundColor:
                                      event.color?.toUpperCase() === "DFF7F9"
                                        ? "#0D47A1"
                                        : `#${event.color || "6c757d"}`,
                                    textDecoration: isPast
                                      ? "line-through"
                                      : "none",
                                  }}
                                >
                                  <i className="bi bi-clock"></i>
                                  <small>
                                    <strong>{formattedTime}</strong>
                                  </small>
                                </div>

                                {event.hasLive && (
                                  <>
                                    {event.liveStatus === "soon" && (
                                      <div className="badge bg-primary ">
                                        Live Soon
                                      </div>
                                    )}

                                    {event.liveStatus === "live" && (
                                      <button
                                        className="btn btn-danger btn-sm  w-20"
                                        onClick={() => joinnow_helper(event)}
                                        disabled={isJoining}
                                      >
                                        <small className="d-flex gap-2 align-items-center justify-content-center">
                                          <LiveTvIcon
                                            color="inherit"
                                            fontSize="inherit"
                                          />{" "}
                                          Join Now
                                        </small>
                                      </button>
                                    )}

                                    {event.liveStatus === "ended" && (
                                      <div className="badge bg-secondary ">
                                        Live Ended
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>

                              <div className="fw-semibold fs-8 d-flex align-items-center gap-2 my-1">
                                <h5 className=" fw-bold fs-8 mb-0">
                                  {event.title}
                                </h5>
                                <span className="badge bg-warning text-dark fw-semibold rounded-pill shadow-sm">
                                  {event.type}
                                </span>
                              </div>

                              <div className="text-muted small">
                                {event.lectureName}
                              </div>
                            </div> */}
                            <div
                              key={event.id || idx}
                              className="shadow-sm border rounded-3"
                              style={{
                                minWidth: "260px",
                                flex: "0 0 auto",
                                opacity: isPast ? 0.5 : 1,
                                padding: "16px",
                                background: "#ffffff",
                              }}
                            >
                              {/* TOP BAR */}
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                {/* TIME CHIP */}
                                <div
                                  className="text-white d-flex align-items-center gap-2 rounded px-2 py-1"
                                  style={{
                                    backgroundColor:
                                      event.color?.toUpperCase() === "DFF7F9"
                                        ? "#0D47A1"
                                        : `#${event.color || "6c757d"}`,
                                    fontSize: "12px",
                                    fontWeight: 600,
                                  }}
                                >
                                  <i className="bi bi-clock"></i>
                                  <span>{formattedTime}</span>
                                </div>

                                {/* LIVE STATUS */}
                                {event.hasLive && (
                                  <>
                                    {event.liveStatus === "soon" && (
                                      <span
                                        className="badge rounded-pill"
                                        style={{
                                          background: "#e6f0ff",
                                          color: "#084298",
                                          fontWeight: 600,
                                        }}
                                      >
                                        Live Soon
                                      </span>
                                    )}

                                    {event.liveStatus === "live" && (
                                      <button
                                        className="btn btn-danger btn-sm d-flex align-items-center gap-1"
                                        onClick={(e) => {
                                          onJoinClick(event);
                                        }}
                                        disabled={isJoining}
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: 600,
                                        }}
                                      >
                                        <LiveTvIcon fontSize="inherit" />
                                        {isJoining
                                          ? "Please wait..."
                                          : "Join Now"}
                                      </button>
                                    )}

                                    {event.liveStatus === "ended" && (
                                      <span
                                        className="badge rounded-pill bg-secondary"
                                        style={{ fontWeight: 600 }}
                                      >
                                        Live Ended
                                      </span>
                                    )}
                                  </>
                                )}
                              </div>

                              {/* TITLE */}
                              <div className="d-flex align-items-center gap-2 mb-1">
                                <h6
                                  className="mb-0 fw-bold"
                                  style={{ fontSize: "14px", color: "#222" }}
                                >
                                  {event.title}
                                </h6>

                                <span
                                  className="badge rounded-pill"
                                  style={{
                                    background: "#ffe082",
                                    color: "#795300",
                                    fontSize: "11px",
                                    fontWeight: 700,
                                  }}
                                >
                                  {event.type}
                                </span>
                              </div>

                              {/* DESCRIPTION */}
                              <div
                                className="text-muted"
                                style={{ fontSize: "13px", lineHeight: "1.4" }}
                              >
                                {event.lectureName}
                              </div>
                            </div>
                          </>
                        );
                      })}
                  </div>
                </div>
              ) : (
                <Box
                  className="col-12"
                  sx={{
                    border: "1px dashed",
                    borderColor: "divider",
                    borderRadius: 2,
                    py: 4,
                    px: 2,
                    textAlign: "center",
                    backgroundColor: "background.paper",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      color: "text.primary",
                      mb: 0.5,
                    }}
                  >
                    A Clear Day
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                    }}
                  >
                    No lectures scheduled for the selected date
                  </Typography>
                </Box>
              )}
            </div>
          </div>

          {JoinNowInstructions && (
            <JoinNowInstructions
              openInstruction={openInstruction}
              setOpenInstruction={setOpenInstruction}
              onContinue={onInstructionContinue}
            />
          )}
        </div>

        {/* timetable schedule */}
        <div class="container-fluid my-4">
          <div class="card shadow-sm">
            <div class="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex flex-column">
                  <strong className="fs-4 mb-1">Schedules</strong>
                  <span className="fs-8 fw-semibold mb-3">
                    Please select fields below to View Timetable.
                  </span>
                </div>
                <div className="d-flex flex-row gap-2 align-items-center justify-content-center">
                  <div
                    className="list_holiday"
                    onClick={() => setTeacherListPopup(true)}
                  >
                    List of Teachers
                  </div>
                  {/* {viewAs && stdSelection && secSelection && (
                    viewAs !== "option3" &&
                    events?.length === 0 &&
                      ? (
                      <button
                        className="edit_time_table"
                        onClick={() => {
                          setCreateClick(true);
                        }}
                      >
                        + Create Timetable
                      </button>
                    ) :
                    <button
                      className="edit_time_table"
                      onClick={() => {
                        navigate("/createTimeTableManually/true");
                      }}
                    >
                      Manage Timetable
                    </button>
                  )} */}
                </div>
              </div>
              <div className="top_of_dcm d-flex">
                <div className="dcm_dropdowns p-0 col-7">
                  <SubStdSelContext.Consumer>
                    {({
                      secSelectedOption,
                      setSecSelectedOption,
                      stdSelectedOption,
                      setStdSelectedOption,
                      setTeacherDCM,
                      setSecSelectedOptionName,
                      setStdSelectedOptionName,
                    }) => (
                      <>
                        <FormControl
                          fullWidth
                          variant="outlined"
                          size="small"
                          sx={{ mr: 2 }}
                        >
                          <InputLabel id="view-as-label">View As</InputLabel>
                          <Select
                            labelId="view-as-label"
                            id="view-as-label"
                            label="View As"
                            value={viewAs}
                            onChange={(e) => {
                              setViewAs(e.target.value);
                              setTeacherDCM(e.target.value);
                              localStorage.setItem("stdSelection", "");
                              localStorage.setItem("secSelection", "");
                              setStdSelection("");
                              setSecSelection("");
                              setEvents([]);
                            }}
                            renderValue={(selected) => {
                              console.log("selected", selected);
                              return selected === "option1"
                                ? "Class Teacher"
                                : selected === "option2"
                                  ? "Coordinator"
                                  : selected === "option3"
                                    ? "General Teacher"
                                    : selected === "option4"
                                      ? "My Lecture"
                                      : "";
                            }}
                          >
                            {jsonRole_CTinformation?.length > 0 && (
                              <MenuItem value="option1">Class Teacher</MenuItem>
                            )}
                            {jsonRole_Coinformation?.length > 0 && (
                              <MenuItem value="option2">Coordinator</MenuItem>
                            )}
                            {jsonRole_Geinformation?.length > 0 && (
                              <MenuItem value="option3">
                                General Teacher
                              </MenuItem>
                            )}
                            <MenuItem value="option4">My Lecture</MenuItem>
                          </Select>
                        </FormControl>
                        {/* Standard */}
                        <FormControl
                          fullWidth
                          variant="outlined"
                          size="small"
                          sx={{ mr: 2 }}
                        >
                          <InputLabel id="standard-label">Standard</InputLabel>
                          <Select
                            labelId="standard-label"
                            label="Standard"
                            id="standard-label"
                            value={stdSelection}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              const selectedObj = stdArr.find(
                                (item) => item.id === selectedId,
                              );

                              const selectedName = selectedObj?.name || "";

                              setStdSelectedOptionName(selectedName);
                              setStdSelection(selectedId);
                              setStdSelectedOption(selectedId);
                              setSecSelection("");
                              localStorage.setItem("stdSelection", "");
                              localStorage.setItem("secSelection", "");
                              localStorage.setItem(
                                "stdSelectionName",
                                selectedName,
                              );
                              setEvents([]);
                            }}
                          >
                            {stdArr?.length > 0 &&
                              [...stdArr]
                                .sort((a, b) => {
                                  const aNum = Number(a.name);
                                  const bNum = Number(b.name);

                                  if (!isNaN(aNum) && !isNaN(bNum)) {
                                    return aNum - bNum;
                                  }
                                  return a.name.localeCompare(b.name);
                                })
                                .map((standard) => (
                                  <MenuItem
                                    key={standard.id}
                                    value={standard.id}
                                  >
                                    {standard.name}
                                  </MenuItem>
                                ))}
                          </Select>
                        </FormControl>

                        {/* Section */}
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel id="section-label">Section</InputLabel>
                          <Select
                            label="Section"
                            labelId="section-label"
                            id="section-label"
                            value={secSelection}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              const selectedObj = secArr.find(
                                (item) => item.id === selectedId,
                              );
                              const selectedName = selectedObj?.name || "";

                              setSecSelectedOptionName(selectedName);
                              setSecSelection(selectedId);
                              setSecSelectedOption(selectedId);
                              localStorage.setItem(
                                "secSelectionName",
                                selectedName,
                              );
                            }}
                          >
                            {secArr?.length > 0 &&
                              [
                                ...new Map(
                                  secArr.map((section) => [
                                    section?.id,
                                    section,
                                  ]),
                                ).values(),
                              ].map((section) => (
                                <MenuItem key={section?.id} value={section?.id}>
                                  {section?.name}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </>
                    )}
                  </SubStdSelContext.Consumer>
                </div>
              </div>
              <div
                className={`d-flex align-items-center mt-2 ${
                  selectedDate && secSelection
                    ? " justify-content-between "
                    : " justify-content-end "
                }`}
              >
                {selectedDate && secSelection && (
                  <Box
                    sx={{
                      px: 3, // horizontal padding
                      py: 1.5, // vertical padding
                      borderRadius: 1,

                      display: "inline-block",

                      minWidth: 120,
                      textAlign: "center",
                    }}
                  >
                    {monthName && (
                      <div className="d-flex align-items-center gap-2">
                        <CalendarTodayIcon sx={{ color: "#0d47a1" }} />
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 600,
                            color: "#0d47a1", // dark blue text
                          }}
                        >
                          {monthName}
                        </Typography>
                      </div>
                    )}
                  </Box>
                )}
                <div>
                  <DatePickerComponent
                    value={selectedDate}
                    placeholder="Choose a date"
                    format="dd MMMM yyyy"
                    floatLabelType="Auto"
                    change={handleDateChange}
                    cssClass="e-outline" // Optional for material-style outline
                  />
                </div>
              </div>
              <div>
                <ScheduleComponent
                  key={events.length}
                  ref={scheduleRef}
                  //fix calender scroll issue
                  style={{ overflow: "scroll", padding: "0px" }}
                  cssClass="schedule-overview"
                  height="510px"
                  selectedDate={selectedDate}
                  currentView="Week"
                  startHour={"06:00"}
                  endHour="23:59"
                  // allowDragAndDrop={editClick}
                  allowDragAndDrop={false}
                  eventRendered={onEventRendered}
                  actionBegin={onActionBegin}
                  eventSettings={{ dataSource: [...events] }}
                  // onCellDoubleClick={onCellDoubleClick}
                  quickInfoTemplates={{
                    header: headerTemplate,
                    content: contentTemplate,
                  }}
                  timeScale={{
                    enable: true,
                    interval: 30,
                    slotCount: 1,
                  }}
                  created={onCreated}
                  editorTemplate={editorTemplate}
                  popupOpen={onPopupOpen}
                  popupClose={onPopupClose}
                  cellClick={null}
                  dragStart={onDragStart}
                  resizeStart={onResizeStart}
                >
                  <ViewsDirective>
                    <ViewDirective
                      option="Day"
                      eventTemplate={dayEventTemplate}
                      popupOpen={onPopupOpen}
                    />
                    <ViewDirective
                      option="Week"
                      eventTemplate={weekEventTemplate}
                    />
                  </ViewsDirective>
                  <Inject services={[Day, Week, Resize]} />
                </ScheduleComponent>
              </div>
              <style>
                {`
  /* Increase row height */
  .e-schedule .e-time-cells-wrap table td,
  .e-schedule .e-work-cells {
    height: 60px !important;
  }

  /* Time slot labels (left side) */
  .e-schedule .e-time-cells {
    font-weight: 600 !important;
    font-size: 14px !important;
    background-color: #fff0c5 !important;
    color: #333 !important;
  }

  /* Header cells (day slots like Sun, Mon...) */
  .e-schedule .e-header-cells {
    font-weight: bold !important;
    font-size: 14px !important;
    background-color: #fff0c5 !important;
    border-right: 1px solid #eee !important;
    text-align: center !important;
    vertical-align: middle !important;
  }

    .e-schedule {
    border: 1px solid #d3d3d3  !important; /* dark gray border */
    border-radius: 4px !important;
  }

  /* Day number and text */
  .e-schedule .e-header-day,
  .e-schedule .e-header-date {
    font-size: 14px !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
    display: block !important;
  }

  .e-schedule .e-header-day {
    font-size: 16px !important;
    font-weight: 700 !important;
  }

  /* Calendar background */
  .e-schedule .e-table {
    background-color: #fffdf5 !important;
  }

  /* Cell border */
  .e-schedule .e-work-cells {
    border: 1px solid #f0e6cc !important;
  }


  /* Week/Month toggle buttons */
  .e-schedule .e-toolbar-items .e-tbar-btn {
    border-radius: 4px !important;
    font-weight: 600 !important;
    color: #333 !important;
  }

  .e-schedule .e-toolbar-items .e-tbar-btn.e-active {
    background-color: #f57c00 !important;
    color: white !important;
  }

  /* Enable vertical scrolling */
.e-schedule .e-content-wrap {
  overflow-y: auto !important;
}

/* Chrome / Edge / Brave */
.e-schedule .e-content-wrap::-webkit-scrollbar {
  width: 8px;
}

.e-schedule .e-content-wrap::-webkit-scrollbar-track {
  background: #f5f5f5;
}

.e-schedule .e-content-wrap::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 4px;
}

.e-schedule .e-content-wrap::-webkit-scrollbar-thumb:hover {
  background-color: #9e9e9e;
}

/* Firefox */
.e-schedule .e-content-wrap {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f5f5f5;
}

`}
              </style>
            </div>
          </div>
        </div>

        {/* nortices and Holidays section */}
        <Add_class_material
          onSucess={handleSucessNotice}
          TodayDate={TodayDate}
          noticeData={noticeData}
          setNoticeData={setNoticeData}
          teacherListPopup={teacherListPopup}
          setTeacherListPopup={setTeacherListPopup}
        />
      </div>
    </>
  );
};

export default TimeTable;
